import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const TopSkusTable = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Skeleton
        variant="rectangular"
        height={400}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography color="textSecondary">No data available</Typography>
      </Box>
    );
  }

  const totalOrderFrequency = data.reduce(
    (sum, item) => sum + item.orderFrequency,
    0
  );

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ mb: 2 }}
      >
        Top 10 SKUs
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>SKU Name</TableCell>
              <TableCell align="right">Frequency</TableCell>
              <TableCell align="right">% of Orders</TableCell>
              <TableCell align="right">Total Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row._id}>
                <TableCell>{row.skuName || "Unknown"}</TableCell>
                <TableCell align="right">{row.orderFrequency}</TableCell>
                <TableCell align="right">
                  {((row.orderFrequency / totalOrderFrequency) * 100).toFixed(
                    1
                  )}
                  %
                </TableCell>
                <TableCell align="right">
                  $
                  {(row.totalValue || 0).toLocaleString("en-CA", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TopSkusTable;
